import type { ReactNode } from 'react';

interface SettingsCardProps {
  title: string;
  action: ReactNode;
  children: ReactNode;
  flushContent?: boolean;
}

export function SettingsCard({ title, action, children, flushContent = false }: SettingsCardProps) {
  return (
    <div className="flex flex-col rounded-[4px] border border-[#BEC7D0] bg-white">
      <div className="flex items-center justify-between px-5 py-5">
        <h3 className="font-['Open_Sans',sans-serif] text-[14px] leading-5 font-semibold text-black">{title}</h3>
        {action}
      </div>
      <div className="w-full border-t border-[#DEE2E7]" />
      <div className={flushContent ? '' : 'px-5 py-5'}>{children}</div>
    </div>
  );
}
